var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminFieldWrapper',[_c('v-textarea',_vm._g(_vm._b({attrs:{"value":_vm.value,"label":_vm.label,"rows":"3"}},'v-textarea',Object.assign({}, _vm.$attrs),false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }